const EVENTS = {
    AUTHENTICATED: 'authenticated',
};

export default EVENTS;



// WEBPACK FOOTER //
// ./src/constants/events.js